import { Box, HStack, Link, Spinner, Stack, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Flex } from '@chakra-ui/layout';
import { ColorfulBar, Heading } from '~/components';
import logo from '~/assets/logo-service-green.png';
import { TextEditor } from '~/components/TextEditor/TextEditor';
import { visualizarCarta } from '~/services/GroupZeroCarbon';
import { PRIVACY_POLICY_URL, STORAGE } from '~/constants';

export const ViewLetter: React.VFC = () => {
  const [isFetching, setIsFetching] = useState(false);
  const { groupId } = useParams<{ groupId: string }>();
  const [mensagem, setMensagem] = useState('');
  useEffect(() => {
    if (groupId) {
      setIsFetching(true);
      visualizarCarta(groupId)
        .then(response => {
          if (response) {
            let msg = response.mensagem;
            if (msg.includes('&lt;NOME_DO_CLIENTE&gt;')) {
              msg = msg!.replaceAll(
                '&lt;NOME_DO_CLIENTE&gt;',
                `${localStorage.getItem(`${STORAGE}:clientes`) || ''}`,
              );
            }
            if (msg.includes('<LINK_DO_CERTIFICADO>')) {
              msg = msg!.replaceAll(
                '<LINK_DO_CERTIFICADO>',
                `${localStorage.getItem(`${STORAGE}:link_cert`) || ''}`,
              );
            }
            if (msg.includes('&lt;CODIGO_DO_CERTIFICADO&gt;')) {
              msg = msg!.replaceAll(
                '&lt;CODIGO_DO_CERTIFICADO&gt;',
                localStorage.getItem(`${STORAGE}:codigo_cert`) || '',
              );
            }
            if (msg.includes('&lt;NOME_DO_PROJETO&gt;')) {
              msg = msg!.replaceAll(
                '&lt;NOME_DO_PROJETO&gt;',
                localStorage.getItem(`${STORAGE}:nome_projeto`) || '',
              );
            }
            if (msg.includes('&lt;TOTAL_DE_TONELADAS&gt;')) {
              msg = msg!.replaceAll(
                '&lt;TOTAL_DE_TONELADAS&gt;',
                `${localStorage.getItem(`${STORAGE}:total_t`) || ''}t`,
              );
            }
            setMensagem(msg);
          }
        })
        .finally(() => setIsFetching(false));
    }
  }, [groupId]);

  return (
    <Flex w="100vw" h="100vh" flexDir="column">
      <ColorfulBar />
      <Box px="8" py="4">
        <Stack py={8} w="70%" gridGap={4} m="0 auto" height="600px">
          <HStack gridGap={1}>
            <Heading>Assunto: Certificado Zero Carbon</Heading>
            {isFetching && <Spinner />}
          </HStack>
          <TextEditor
            value={mensagem}
            visualizacao
            styles={{ height: '70vh' }}
          />
          <HStack justifyContent="space-between">
            <img src={logo} alt="" width="100px" />
            <HStack fontSize="14px" gridGap={1}>
              <Text>
                © Positivo Tecnologia · Todos os direitos reservados ·{' '}
              </Text>
              <Link
                isExternal
                m="0px !important"
                fontWeight="500"
                _hover={{ textDecoration: 'none' }}
                textDecoration="none"
                color="#3b61f9"
                href={PRIVACY_POLICY_URL}
              >
                Política de privacidade
              </Link>
            </HStack>
          </HStack>
        </Stack>
      </Box>
    </Flex>
  );
};
